import api from "../config";

export const documentsAPI = {
  uploadDocument: async (groupId, name, file) => {
    const formData = new FormData();
    formData.append('groupId', groupId);
    formData.append('name', name);
    formData.append('file', file);

    const response = await api.post("/documents/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return response.data;
  },

  getDocumentsByGroup: async (groupId) => {
    const { data } = await api.get(`/documents/group/${groupId}`);
    return data;
  },

  downloadDocument: async (groupId, filename) => {
    const response = await api.get(`/documents/download/${groupId}/${filename}`, {
      responseType: "blob"
    });
    return response.data;
  },
  getFields: async (documentId) => {
    const { data } = await api.get(`/documents/fields/${documentId}`);
    return data;
  },

  generatePDF: async (payload) => {
    const response = await api.post("/documents/generate", payload, {
      responseType: "blob",
    });
    return response.data;
  },
  resolveDocumentId: async (groupId, filename) => {
    const { data } = await api.get(`/documents/resolve-id`, {
      params: { groupId, filename }
    });
    return data.documentId;
  },
};
